import request from '@/config/axios'

export interface GreetSceneConfig {
  id?: number
  enabled: boolean
  dailyQuota: number
  disturbThreshold: number
  version: number
}

export const getGreetScenePage = (params: any) =>
  request.get({ url: '/bosscircle/greet-scene/page', params })

export const getGreetSceneConfig = () =>
  request.get<GreetSceneConfig>({ url: '/bosscircle/greet-scene/config' })

export const saveGreetSceneConfig = (data: GreetSceneConfig) =>
  request.put({ url: '/bosscircle/greet-scene/config', data })

export const getWeatherPreview = (provinceName: string, cityName: string) =>
  request.get({
    url: '/bosscircle/greet-scene/weather-preview',
    params: { provinceName, cityName }
  })
